import { IConfigService } from '@cs/performance-manager/shared';

export abstract class ErrorConfigService implements IConfigService {
  moduleName = 'error';

  abstract supportEmail: string;
  abstract homeUrl: string[];
}
